export default __webpack_public_path__ + "static/media/projeto2.56d93a6c.PNG";